<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fill="#F0F0F0" d="M19 10c0 4.971-4.029 9-9 9s-9-4.029-9-9 4.029-9 9-9 9 4.029 9 9z"/><path fill="#FF883E" d="M18.995 10a9 9 0 00-5.87-8.44v16.88a9 9 0 005.87-8.44z"/><path fill="#169B62" d="M1 10a9 9 0 005.87 8.44V1.56A9 9 0 001 10z"/><g fill="none" transform="translate(1 1)"><circle cx="9" cy="9" r="9"/><circle cx="9" cy="9" r="9.5" stroke="#E4E4E4"/></g></svg>
</template>

<script>
  export default {
    name: 'en-IE',
  };
</script>
